<div class="container" style="max-width:1024px">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12" style="display: flex;">
      <div class="col-sm-8 col-lg-11 col-md-10">
        <app-menu style="width:inherit;max-width:inherit;background-color:#ffffff;"></app-menu>
      </div>
      <div class="col-sm-4 col-lg-1 col-md-2">
        <img src="assets/images/gsk.png" style="max-width: 65px;padding: 10px 0px 0px 0px;" />
      </div>
    </div>
  </div>
  <div class="row header-padding" style="height:100%;">

    <div class="col-lg-12 col-md-12 col-sm-12">
      <div>
        <div style="width:100%;display:inline-block;float:left;">
          <img src="assets/images/home-logo.jpg" class="home-logo" style="width:100%;" />
        </div>
        <!-- <div style="width:40%;display:inline-block;float:right;text-align: right;">
          <img src="assets/images/gsk.png" style="width:70%;max-width:80px" />
        </div> -->
      </div>

      <!--<table style="width:100%">
        <tr>
          <td> </td>
          <td style="text-align:right;"><img src="assets/images/gsk.png" style="width:80px;" /></td>
        </tr>
        <tr>
          <td style="text-align:center" colspan="2">

          </td>
        </tr>
      </table>-->
    </div>
  </div>
  <!--  <div class="col-lg-12 col-md-12 col-sm-12" style="padding:0px;text-align:center">
    <button routerLink="/page/intro" class="btn btn-primary btn-start">Start</button>
  </div> -->
  <img src="assets/images/home-people.jpg"
    style="width:100vw;max-width:1024px;margin:0px auto;bottom:0;position:fixed;z-index:-99;" />

  <!--<img src="assets/images/panadol-logo.png" style="width:50%;position:fixed;top:50px;max-width:100px;" />
  <img src="assets/images/home.jpg" style="width:100%;position:absolute;bottom:0px;" />-->

</div>
